import { getVersionAnchor } from "./getVersionAnchor";
export const scrollToRelease = (version) => (e) => {
    var _a;
    const anchor = getVersionAnchor(version);
    (_a = document.getElementById(anchor)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
    e.preventDefault();
    return false;
};
